import { LOADING, SET_FEATURE_FLAG } from "../actionTypes";
import { initialState } from "../initialState";

export const globalReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_FEATURE_FLAG:
      return {
        ...state,
        featureFlag: action.payload,
      };
    default:
      return state;
  }
};
